export type TModelType = 'userBased' | 'itemBased' | 'historyBased';

export interface ISimilarOffersReceivedData {
  modelVersion?: string | null;
  offers: ISimilarOffer[];
  withoutCompetitors?: boolean | null;
}

export enum ETransportType {
  Transport = 'transport',
  Walk = 'walk',
}

export interface ISimilarOfferUnderground {
  color: string;
  iconType?: string | null;
  name: string;
  time?: string | null;
  transportType?: ETransportType | null;
}

export interface ISimilarOffer {
  address: string;
  cianId: number;
  formattedPrice: string;
  gaVariant: string;
  photoUrl?: string | null;
  publishedUserId?: number | null;
  realtyId: number;
  title: string;
  totalPriceRur: number;
  underground?: ISimilarOfferUnderground | null;
  url: string;
}

export interface ISimilarState {
  userBased: {
    list: ISimilarOffer[];
    withoutCompetitors: boolean | null;
    modelVersion: string | null;
  };
  itemBased: {
    list: ISimilarOffer[];
    withoutCompetitors: boolean | null;
    modelVersion: string | null;
  };
  historyBased: {
    list: ISimilarOffer[];
    withoutCompetitors: boolean | null;
    modelVersion: string | null;
  };
}
